import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './TireInformation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const TireInformation = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let tirePressureStatus: ReactElement | null = null;
    if (props.connectedVehicle.tirePressureValue) {
        let tirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressureTstamp) {
            tirePressureTstamp =
                <p className={css.statusLit}>{strings.DataAsOf + ' ' + props.connectedVehicle.tirePressureTstamp}</p>;
        }

        tirePressureStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.TirePressureStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressureValue}
                </div>
                {tirePressureTstamp}
            </span>;
    }

    let tirePressureByLoc: ReactElement | null = null;
    if (props.connectedVehicle.tirePressureLocValue) {
        let tirePressureLocTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressureLocTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressureLocStatus) {
                statusLit = props.connectedVehicle.tirePressureLocStatus + ' ' + strings.AsOf;
            }
            tirePressureLocTstamp =
                <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressureLocTstamp}</p>;
        }

        tirePressureByLoc =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.TirePressureByLocation}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressureLocValue}
                </div>
                {tirePressureLocTstamp}
            </span>;
    }

    let tirePressureSystem: ReactElement | null = null;
    if (props.connectedVehicle.tirePressureSysValue) {
        let tirePressureSysTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressureSysTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressureSysStatus) {
                statusLit = props.connectedVehicle.tirePressureSysStatus + ' ' + strings.AsOf;
            }
            tirePressureSysTstamp =
                <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressureSysTstamp}</p>;
        }

        tirePressureSystem =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.TirePressureSystem}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressureSysValue}
                </div>
                {tirePressureSysTstamp}
            </span>;
    }

    let tireSpeed: ReactElement | null = null;
    if (props.connectedVehicle.tireSpeedValue) {
        tireSpeed =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.TireSpeed}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireSpeedValue}
                </div>
            </span>;
    }

    let generalData: ReactElement | null = null;
    if (tireSpeed || tirePressureStatus || tirePressureByLoc || tirePressureSystem) {
        generalData =
        <div>
            <hr></hr>
            <div className={css.infoRow}>
                {tireSpeed}
                {tirePressureStatus}
                {tirePressureByLoc}
                {tirePressureSystem}
            </div>
        </div>;
    }

    let general: ReactElement | null = null;
    if (generalData) {
        general =
            <div>
                <div className={css.headerLit}>
                    {strings.General}
                </div>
                {generalData}
            </div>;
    }

    let recomFrontPressure: ReactElement | null = null;
    if (props.connectedVehicle.tireFrontRecomValue) {
        let recomFrontTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireFrontRecomTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireFrontRecomStatus) {
                statusLit = props.connectedVehicle.tireFrontRecomStatus + ' ' + strings.AsOf;
            }
            recomFrontTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireFrontRecomTstamp}</p>;
        }

        recomFrontPressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.RecommendedFrontPressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireFrontRecomValue}
                </div>
                {recomFrontTstamp}
            </span>;
    }

    let recomFront: ReactElement | null = null;
    if (recomFrontPressure) {
        recomFront =
            <div>
                <hr></hr>
                <div className={css.infoRow}>
                    {recomFrontPressure}
                </div>
            </div>;
    }

    let lfTirePressure: ReactElement | null = null;
    if (props.connectedVehicle.tirePressLFValue) {
        let lfTirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressLFTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressLFStatus) {
                statusLit = props.connectedVehicle.tirePressLFStatus + ' ' + strings.AsOf;
            }
            lfTirePressureTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressLFTstamp}</p>;
        }

        lfTirePressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LeftFrontTirePressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressLFValue}
                </div>
                {lfTirePressureTstamp}
            </span>;
    }

    let rfTirePressure: ReactElement | null = null;
    if (props.connectedVehicle.tireRFValue) {
        let rfTirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressRFTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressRFStatus) {
                statusLit = props.connectedVehicle.tirePressRFStatus + ' ' + strings.AsOf;
            }
            rfTirePressureTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressRFTstamp}</p>;
        }

        rfTirePressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.RightFrontTirePressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressRFValue}
                </div>
                {rfTirePressureTstamp}
            </span>;
    }

    let lfTireStatus: ReactElement | null = null;
    if (props.connectedVehicle.tireLFValue) {
        let lfTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireLFTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireLFStatus) {
                statusLit = props.connectedVehicle.tireLFStatus + ' ' + strings.AsOf;
            }
            lfTireTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireLFTstamp}</p>;
        }

        lfTireStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LeftFrontTireStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireLFValue}
                </div>
                {lfTireTstamp}
            </span>;
    }

    let rfTireStatus: ReactElement | null = null;
    if (props.connectedVehicle.tireRFValue) {
        let rfTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireRFTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireRFStatus) {
                statusLit = props.connectedVehicle.tireRFStatus + ' ' + strings.AsOf;
            }
            rfTireTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireRFTstamp}</p>;
        }

        rfTireStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.RightFrontTireStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireRFValue}
                </div>
                {rfTireTstamp}
            </span>;
    }

    let actualFront: ReactElement | null = null;
    if (lfTirePressure || rfTirePressure || lfTireStatus || rfTireStatus) {
        actualFront =
        <div>
            <hr></hr>
            <div className={css.infoRow}>
                {lfTirePressure}
                {rfTirePressure}
                {lfTireStatus}
                {rfTireStatus}
            </div>
        </div>;
    }

    let front: ReactElement | null = null;
    if (recomFront || actualFront) {
        front =
            <div>
                <div className={css.headerLit}>
                    {strings.FrontTires}
                </div>
                {recomFront}
                {actualFront}
            </div>;
    }

    let recomRearPressure: ReactElement | null = null;
    if (props.connectedVehicle.tireRearRecomValue) {
        let recomRearTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireRearRecomTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireRearRecomStatus) {
                statusLit = props.connectedVehicle.tireRearRecomStatus + ' ' + strings.AsOf;
            }
            recomRearTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireRearRecomTstamp}</p>;
        }

        recomRearPressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.RecommendedRearPressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireRearRecomValue}
                </div>
                {recomRearTstamp}
            </span>;
    }

    let dualRearWheels: ReactElement | null = null;
    if (props.connectedVehicle.tireDualRearValue) {
        let dualRearTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireDualRearTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireDualRearStatus) {
                statusLit = props.connectedVehicle.tireDualRearStatus + ' ' + strings.AsOf;
            }
            dualRearTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireDualRearTstamp}</p>;
        }

        dualRearWheels =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.DualRearWheels}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireDualRearValue}
                </div>
                {dualRearTstamp}
            </span>;
    }

    let recomRear: ReactElement | null = null;
    if (recomRearPressure || dualRearWheels) {
        recomRear =
            <div>
                <hr></hr>
                <div className={css.infoRow}>
                    {recomRearPressure}
                    {dualRearWheels}
                </div>
            </div>;
    }

    let lrTirePressure: ReactElement | null = null;
    if (props.connectedVehicle.tirePressLRValue) {
        let lrTirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressLRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressLRStatus) {
                statusLit = props.connectedVehicle.tirePressLRStatus + ' ' + strings.AsOf;
            }
            lrTirePressureTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressLRTstamp}</p>;
        }

        lrTirePressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LeftRearTirePressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressLRValue}
                </div>
                {lrTirePressureTstamp}
            </span>;
    }

    let rrTirePressure: ReactElement | null = null;
    if (props.connectedVehicle.tireRRValue) {
        let rrTirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressRRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressRRStatus) {
                statusLit = props.connectedVehicle.tirePressRRStatus + ' ' + strings.AsOf;
            }
            rrTirePressureTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressRRTstamp}</p>;
        }

        rrTirePressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.RightRearTirePressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressRRValue}
                </div>
                {rrTirePressureTstamp}
            </span>;
    }

    let lrTireStatus: ReactElement | null = null;
    if (props.connectedVehicle.tireLRValue) {
        let lrTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireLRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireLRStatus) {
                statusLit = props.connectedVehicle.tireLRStatus + ' ' + strings.AsOf;
            }
            lrTireTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireLRTstamp}</p>;
        }

        lrTireStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LeftRearTireStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireLRValue}
                </div>
                {lrTireTstamp}
            </span>;
    }

    let rrTireStatus: ReactElement | null = null;
    if (props.connectedVehicle.tireRRValue) {
        let rrTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireRRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireRRStatus) {
                statusLit = props.connectedVehicle.tireRRStatus + ' ' + strings.AsOf;
            }
            rrTireTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireRRTstamp}</p>;
        }

        rrTireStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.RightRearTireStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireRRValue}
                </div>
                {rrTireTstamp}
            </span>;
    }

    let actualRear: ReactElement | null = null;
    if (lrTirePressure || rrTirePressure || lrTireStatus || rrTireStatus) {
        actualRear =
        <div>
            <hr></hr>
            <div className={css.infoRow}>
                {lrTirePressure}
                {rrTirePressure}
                {lrTireStatus}
                {rrTireStatus}
            </div>
        </div>;
    }

    let ilrTirePressure: ReactElement | null = null;
    if (props.connectedVehicle.tirePressILRValue) {
        let ilrTirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressILRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressILRStatus) {
                statusLit = props.connectedVehicle.tirePressILRStatus + ' ' + strings.AsOf;
            }
            ilrTirePressureTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressILRTstamp}</p>;
        }

        ilrTirePressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.InnerLeftRearTirePressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressILRValue}
                </div>
                {ilrTirePressureTstamp}
            </span>;
    }

    let irrTirePressure: ReactElement | null = null;
    if (props.connectedVehicle.tireIRRValue) {
        let irrTirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressIRRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressIRRStatus) {
                statusLit = props.connectedVehicle.tirePressIRRStatus + ' ' + strings.AsOf;
            }
            irrTirePressureTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressIRRTstamp}</p>;
        }

        irrTirePressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.InnerRightRearTirePressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressIRRValue}
                </div>
                {irrTirePressureTstamp}
            </span>;
    }

    let ilrTireStatus: ReactElement | null = null;
    if (props.connectedVehicle.tireILRValue) {
        let ilrTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireILRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireILRStatus) {
                statusLit = props.connectedVehicle.tireILRStatus + ' ' + strings.AsOf;
            }
            ilrTireTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireILRTstamp}</p>;
        }

        ilrTireStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.InnerLeftRearTireStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireILRValue}
                </div>
                {ilrTireTstamp}
            </span>;
    }

    let irrTireStatus: ReactElement | null = null;
    if (props.connectedVehicle.tireIRRValue) {
        let irrTireTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tireIRRTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tireIRRStatus) {
                statusLit = props.connectedVehicle.tireIRRStatus + ' ' + strings.AsOf;
            }
            irrTireTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tireIRRTstamp}</p>;
        }

        irrTireStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.InnerRightRearTireStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireIRRValue}
                </div>
                {irrTireTstamp}
            </span>;
    }

    let actualInnerRear: ReactElement | null = null;
    if (ilrTirePressure || irrTirePressure || ilrTireStatus || irrTireStatus) {
        actualInnerRear =
        <div>
            <hr></hr>
            <div className={css.infoRow}>
                {ilrTirePressure}
                {irrTirePressure}
                {ilrTireStatus}
                {irrTireStatus}
            </div>
        </div>;
    }

    let rear: ReactElement | null = null;
    if (recomRear || actualRear || actualInnerRear) {
        rear =
            <div>
                <div className={css.headerLit}>
                    {strings.RearTires}
                </div>
                {recomRear}
                {actualRear}
                {actualInnerRear}
            </div>;
    }

    let spareTirePressure: ReactElement | null = null;
    if (props.connectedVehicle.tirePressSpareValue) {
        let spareTirePressureTstamp: ReactElement | null = null;
        if (props.connectedVehicle.tirePressSpareTstamp) {
            let statusLit = strings.DataAsOf;
            if (props.connectedVehicle.tirePressSpareStatus) {
                statusLit = props.connectedVehicle.tirePressSpareStatus + ' ' + strings.AsOf;
            }
            spareTirePressureTstamp =
                <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.tirePressSpareTstamp}</p>;
        }

        spareTirePressure =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.SpareTirePressure}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tirePressSpareValue}
                </div>
                {spareTirePressureTstamp}
            </span>;
    }

    let spareTireStatus: ReactElement | null = null;
    if (props.connectedVehicle.tireSpareValue) {
        spareTireStatus =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.SpareTireStatus}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.tireSpareValue}
                </div>
            </span>;
    }

    let spareTire: ReactElement | null = null;
    if (spareTirePressure || spareTireStatus) {
        spareTire =
            <div>
                <hr></hr>
                <div className={css.infoRow}>
                    {spareTirePressure}
                    {spareTireStatus}
                </div>
            </div>;
    }

    let spare: ReactElement | null = null;
    if (spareTire) {
        spare =
            <div>
                <div className={css.headerLit}>
                    {strings.SpareTire}
                </div>
                {spareTire}
            </div>;
    }

    return (
        <div className={css.block}>
            <div className={css.icon}>
                <IconSeeMore onClick={() => toggleInfo()} />
            </div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.TireInformation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    {general}
                    {front}
                    {rear}
                    {spare}
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default TireInformation;